/** Environment configuration (public client config — no secrets). */
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  clientId: import.meta.env.VITE_ENTRA_CLIENT_ID,
  tenantId: import.meta.env.VITE_ENTRA_TENANT_ID,
  apiScope: import.meta.env.VITE_API_SCOPE,
  // Cloudflare Turnstile site key (PUBLIC — embedded in client HTML, safe to commit). Production key
  // for arvetio.com / panel.arvetio.com. Overridable via VITE_TURNSTILE_SITE_KEY at build time.
  turnstileSiteKey: (import.meta.env.VITE_TURNSTILE_SITE_KEY as string) || "0x4AAAAAAEM3FR5oru8x1Jf8",
};

// Owner logs in from the owner's own tenant only (single-tenant authority).
export const authority = `https://login.microsoftonline.com/${config.tenantId}`;
